import { render, staticRenderFns } from "./prodotti.vue?vue&type=template&id=d1deb798&"
import script from "./prodotti.vue.ts?vue&type=script&lang=ts&"
export * from "./prodotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports